(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forma-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-forma-home]').forEach(function(root){
    var modules=root.querySelectorAll('[data-step]');
    var progress=root.querySelector('[data-forma-progress]');
    var status=root.querySelector('[data-forma-status]');
    var copy=[['Your product','Defined','Premium','Start with one direction.','Every asset follows the same campaign world.'],['Exact identity','Materials','Protected','Lock the product.','Keep shape, color and typography consistent.'],['Six shot roles','Four ratios','Ready','Direct every image.','Hero, lifestyle, detail, UGC and ads.'],['Natural motion','Platform ready','Controlled','Move the camera.','Keep motion realistic and product-safe.'],['Hooks to email','One voice','Complete','Turn direction into sales.','Hooks, scripts, ads and emails—ready to launch.']];
    function activate(index){modules.forEach(function(button,i){button.classList.toggle('active',i===index)});progress.style.width=((index+1)*20)+'%';status.textContent='MODULE 0'+(index+1)+' / '+(index===4?'CAMPAIGN READY':'IN PROGRESS');var fields=root.querySelectorAll('.forma-screen>div b');fields.forEach(function(field,i){field.textContent=copy[index][i]});root.querySelector('.forma-screen h2').textContent=copy[index][3];root.querySelector('.forma-screen p').textContent=copy[index][4]}
    modules.forEach(function(button){button.addEventListener('click',function(){activate(Number(button.dataset.step))})});
    var demo=root.querySelector('[data-forma-demo]');if(demo){demo.addEventListener('click',function(){root.querySelector('#forma-system').scrollIntoView({behavior:'smooth'})})}
  });
  document.querySelectorAll('[data-forma-story]').forEach(function(story){
    var scenes=story.querySelectorAll('[data-story-scene]');
    var steps=story.querySelectorAll('[data-story-step]');
    var buttons=story.querySelectorAll('[data-story-jump]');
    var count=story.querySelector('[data-story-count]');
    var copy=story.querySelector('.forma-story-copy');
    var kicker=story.querySelector('[data-story-kicker]');
    var title=story.querySelector('[data-story-title]');
    var textNode=story.querySelector('[data-story-text]');
    var content=[
      ['START WITH ONE PRODUCT','Give it a<br><em>direction.</em>','FORMA turns the product into a campaign system.'],
      ['01 / CAMPAIGN BUILDER','Define the<br><em>world.</em>','Audience, positioning and creative direction—aligned.'],
      ['02 / PRODUCT LOCK','Keep it<br><em>recognizable.</em>','Shape, materials and typography stay consistent.'],
      ['03–04 / VISUALS + MOTION','Build the<br><em>campaign.</em>','Hero, ecommerce, UGC, ads and motion from one system.'],
      ['05 / LAUNCH COPY','Ready to<br><em>launch.</em>','Every visual and message speaks the same language.']
    ];
    var active=0;
    function show(index){
      if(index===active&&scenes[index].classList.contains('active'))return;
      active=index;copy.classList.add('is-changing');
      window.setTimeout(function(){kicker.textContent=content[index][0];title.innerHTML=content[index][1];textNode.textContent=content[index][2];copy.classList.remove('is-changing')},170);
      scenes.forEach(function(scene,i){var selected=i===index;scene.classList.toggle('active',selected);scene.setAttribute('aria-hidden',selected?'false':'true')});
      buttons.forEach(function(button,i){button.classList.toggle('active',i===index)});
      count.textContent='0'+(index+1)+' / 05';
    }
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting)show(Number(entry.target.dataset.storyStep))})},{rootMargin:'-42% 0px -42% 0px',threshold:0});
    steps.forEach(function(step){observer.observe(step)});
    buttons.forEach(function(button){button.addEventListener('click',function(){steps[Number(button.dataset.storyJump)].scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'})})});
    var mobileQuery=window.matchMedia('(max-width: 900px)');
    var scrollTicking=false;
    function updateMobileStory(){
      scrollTicking=false;
      if(!mobileQuery.matches||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      var rect=story.getBoundingClientRect();
      var distance=Math.max(1,story.offsetHeight-window.innerHeight);
      var progress=Math.min(1,Math.max(0,-rect.top/distance));
      var index=Math.min(scenes.length-1,Math.floor(progress*scenes.length));
      show(index);
    }
    function requestMobileStory(){
      if(!scrollTicking){scrollTicking=true;window.requestAnimationFrame(updateMobileStory)}
    }
    window.addEventListener('scroll',requestMobileStory,{passive:true});
    window.addEventListener('resize',requestMobileStory,{passive:true});
    requestMobileStory();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
